export default "__VITE_ASSET__bf5455b7__"